export const experience = {
  title: 'Experience',
  subtitle: 'Work and Internship',
  description:
    'Worked with many evolving startups as ML and DL Developer, Designer and Software Architect and also worked with some well established companies mostly as AI Developer. I love organising events and that is why I am also involved with many opensource communities as a representative.',
  header_image_path: 'experience.svg',
  sections: [
    {
      title: 'Work Experience',
      experiences: [
        {
          title: 'Associate Software Engineer',
          company: 'Accenture',
          company_url: 'https://www.accenture.com/ph-en',
          logo_path: 'accenture-logo.png',
          duration: 'November 2016 - January 2018',
          location: 'Mckinley, Taguig',
          description:
            'Successfully built, tested, and deployed all projects handled as part of the SAP MM-WM team.',
          color: '#9b1578',
        },
        {
          title: 'Front-End Web Developer',
          company: 'Icefox Technology Incorporated',
          logo_path: 'icefox-logo.png',
          duration: 'August 2019 - May 2020',
          location: 'BGC, Taguig',
          description:
            'Wrote well designed, testable, efficient code by using best software development practices. Created website layout/user interfaces by using React.js and Material UI. Integrated data from various back-end services and databases (Apollo Express, GraphQL). Maintained website by fixing bugs and provide improvements on the website.',
          color: '#0879bf',
        },
        {
          title: 'Front-End Software Engineer',
          company: 'Multisys Technologies Corporation',
          company_url: 'https://www.multisyscorp.com/',
          logo_path: 'multisys-logo.png',
          duration: 'September 2020 - Present',
          location: 'Multinational Village, Moonwalk, Paranaque City',
          description:
            'Writing well designed, testable, efficient code by using best software development practices. Creating website layout/user interfaces by using React.js with Redux. Integrating data from various back-end services and databases (JAVA). Maintain website by fixing bugs and providing improvements on the website.',
          color: '#d64649',
        },
      ],
    },
    {
      title: 'Internship',
      experiences: [
        {
          title: 'IT - Intern',
          company: 'Bureau of Internal Revenue, IT Department',
          company_url: 'https://www.bir.gov.ph/',
          logo_path: 'bir-logo.png',
          duration: 'June 2016 - Sept 2016 ( 3 months )',
          location: 'BIR Road, Diliman, Quezon City',
          description:
            'Worked on a project that helped in realizing what it feels like to be a professional in the IT industry.',
          color: '#ee3c26',
        },
      ],
    },
  ],
};
